module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEZSURBVEhL7ZQ9bsJAEIVNEF2OkQvkCHSIREqQuANXAG4ABRfhGIkEqUJNS0mRAlHx+56TRc+TXS/r2p/0yezM7AMttrOaqjzCr9+PORfjJ6xMA84hgxz2C7SXzBjaEA22vSQ68AhtiAaH3MIJbEEvT/AH6iaH1mJOoRf+qXbYYevac7ThAfIEnlmw+ELK9DGD7C3hAwuKDYjpg7f3BrI/YEGxATFD9CH763wl2ICYIZqQ/XO+EmxAzDK8M7r5HkkPruAefsN3SHTmhm6+R4bxGLTG9ZusC+jgEPKOGEktZNlsgQ/oGtxAeNUNPkOzzPsHHxA2+Wu4wb34FtCSMnvjBdpzPcEutKTMFniFfC/t/q5ch0iZrfGRZVenQeJly8SSdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-garbage-truck/dark/24.png
// module id = 2094
// module chunks = 2